import React from 'react';
import Toolbar from './toolbar';
import LayerTogglers from './layer-togglers';

const MapToolbar = ({
    // Drawing tools
    drawPolygon,
    drawCircle,
    stopDrawing,
    toggleDrawHouse,
    undo,
    undoIsActive,
    hasAreas,
    isLoading,
    
    // Selection
    selectionType,
    hasSelectionType,
    onSelectionChange,
    
    // Filter and search
    onToggleFilterModal,
    filterModalIsOpen,
    allUnits,
    units,
    selectSearchedArea,
    numberOfUnits,
    
    // Map type
    type,
    
    // Layer toggles
    onToggleUnits,
    onToggleSaleDistricts,
    unitsVisible,
    onToggleDemographics,
    onToggleOverlayArea,
    
    // Tools
    onAddTools
}) => {
    return (
        <>
            <div className="create-district-map__toolbar">
                <Toolbar 
                    // Drawing tools
                    drawPolygon={drawPolygon}
                    drawCircle={drawCircle}
                    stopDrawing={stopDrawing}
                    toggleDrawHouse={toggleDrawHouse}
                    undo={undo}
                    undoIsActive={undoIsActive}
                    hasAreas={hasAreas}
                    isLoading={isLoading}
                    
                    // Selection
                    selectionType={selectionType}
                    hasSelectionType={hasSelectionType}
                    changeSelection={onSelectionChange}
                    
                    // Filter and search
                    toggleFilterModal={onToggleFilterModal}
                    filterModalIsOpen={filterModalIsOpen}
                    allUnits={allUnits}
                    units={units}
                    selectSearchedArea={selectSearchedArea}
                    numberOfUnits={numberOfUnits}
                    unitsVisible={unitsVisible}
                    
                    // Map type
                    type={type}
                    
                    // Tools
                    addTools={onAddTools}
                />
            </div>

            <div className="toolbar create-district-map__toolbar-bottom">
                <LayerTogglers 
                    type={type}
                    toggleUnits={onToggleUnits}
                    unitsVisible={unitsVisible}
                    toggleDemographics={onToggleDemographics}
                    toggleSaleDistricts={onToggleSaleDistricts}
                    toggleOverlayArea={onToggleOverlayArea}
                />
            </div>
        </>
    );
};

export default MapToolbar;